import PayResultPage from '@/views/profile/PayResultPage'

export default function PayResultScreen() {
  return <PayResultPage />
}
